<h1 class="page-title mb-5">المناطق الحرة
</h1>
<div>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-9">
        <div style="
            background-color: var(--color-gafi-border);
            border-right: 5px var(--color-primary) solid;
          " class="mb-4">
          <p style="font-size: 16px; color: var(--color-gray-444)" class="p-2">
            المناطق الحرة
          </p>
        </div>
        <p>تعد المناطق الحرة أحد الأنظمة الاستثمارية المميزة التي أولتها الدولة المصرية اهتماما كبيرا لما لها من مردود
          ايجابى كبير على الأداء الاقتصادى للبلاد .</p>
        <p class="pcolor">التشريعات المنظمة للمناطق الحرة</p>
        <p>تخضع المناطق الحرة لأحكام قانون الاستثمار رقم 72 لسنة 2017 ولائحته التنفيذية وتعديلاتهما ولائحة نظام إدارة
          المناطق الحرة الصادرة بقرار وزيرة الاستثمار رقم 39 لسنة 2019 ، وتشرف على تطبيقه الهيئة العامة للاستثمار
          والمناطق الحرة .</p>
        <p class="pcolor">ما هي المناطق الحرة</p>
        <p>هي جزء من إقليم الدولة يدخل ضمن حدودها ويخضع لسلطتها الإدارية ، ويتم التعامل فيه وفقاً لاحكام ضريبية وجمركية
          ونقدية خاصة.</p>
        <p class="pcolor">الأنشطة المصرح بها في المناطق الحرة</p>
        <p>يسمح بمزاولة كافة الأنشطة المراد الاستثمار بها داخل المناطق الحرة وفقاً للسياسة التي تضعها الهيئة العامة
          للاستثمار والمناطق الحرة وبصفة أساسية الصناعات الموجهة للتصدير للخارج باستثناء الصناعات التالية :</p>
        <ul>
          <li>صناعات الخمور والمواد الكحولية.</li>
          <li>صناعات الأسلحة والذخائر والمتفجرات وغيرها مما يرتبط بالأمن القومي.</li>
        </ul>

        <p>وقد صدر <span style="font-weight: bold; text-decoration: underline;">القانون رقم 160 لسنة 2023</span>
          بتعديل بعض أحكام قانون الاستثمار رقم 72 لسنة 2017 متضمنا السماح بمزاولة النشاط لبعض الأنشطة التي كان محظور
          مزاولتها بنظام المناطق الحرة حيث تم التعديل بالمادة 34 بالنص على مايلي:-</p>
        <p>((....يجوز بعد موافقة <span style="font-weight: bold; text-decoration: underline;">المجلس الاعلى
            للطاقة</span>
          الترخيص بإقامة مشروعات
          بنظام المناطق الحرة فى مجال تصنيع البترول - صناعة الأسمدة - الحديد والصلب - تصنيع وتسييل ونقل الغاز الطبيعي -
          الصناعات كثيفة استخدام الطاقة))</p>

        <p class="pcolor">الاعفاءات والضمانات والمزايا التي تمنح للمشروع</p>
        <p>وفرت الدولة ممثلة في الهيئة العامة للاستثمار والمناطق الحرة كل عوامل النجاح في المناطق الحرة من خلال منظومة
          متكاملة تتمثل فى توفير أفضل المزايا والحوافز والإعفاءات والضمانات إذا ما قورنت بمثيلتها على مستوى المنطقة
          الإقليمية.</p>

        <p class="pcolor">الإعفاءات</p>
        <ul>
          <li>إعفاء كافة الأصول الرأسمالية ومستلزمات الإنتاج اللازمة لمزاولة نشاط المشروع (عدا سيارات الركوب) من أية
            رسوم جمركية أو ضرائب على القيمة المضافة أو غيرها من الضرائب <span
              style="font-weight: bold; text-decoration: underline;">طوال فترة مزاولة النشاط</span> حتى لو اقتضت طبيعة
            النشاط تواجدها بصفة مؤقتة خارج المنطقة الحرة .</li>
          <li>إعفاء صادرات وواردات المشروع من وإلى خارج البلاد من أية رسوم جمركية أو ضرائب سواء كانت ضرائب على القيمة
            المضافة أو غيرها من الضرائب أو الرسوم المعمول بها داخل البلاد.</li>
          <li>عدم خضوع المشروع وأرباحه للقوانين أو التشريعات الضريبية أو الجمركية المعمول بها داخل البلاد <span
              style="font-weight: bold; text-decoration: underline;">طوال فترة مزاولة النشاط</span> .</li>
          <li>عدم خضوع واردات وصادرات المشروع من وإلى خارج البلاد لأي إجراءات جمركية أو قواعد استيرادية عادية معمول بها
            داخل البلاد.</li>
          <li>إعفاء واردات المشروع من السوق المحلي من الضرائب على القيمة المضافة.</li>
          <li>إعفاء بضائع الترانزيت المحددة الوجهة من سداد أية رسوم مقررة على السلع الداخلة والخارجة وفقاً للشروط
            التالية:
            <ul>
              <li>أن يكون المشروع داخل الدائرة الجمركية.</li>
              <li>أن تكون محددة الوجهة النهائية ببوليصة الشحن والفاتورة.</li>
            </ul>
          </li>
          <li>إعفاء كامل المكونات المحلية للسلع المنتجة بمشروعات المناطق الحرة من الرسوم الجمركية عليها في حالة البيع
            للسوق المحلي (داخل البلاد).</li>
        </ul>

        <p class="pcolor">الضمانات</p>
        <ul>
          <li><span style="font-weight: bold; text-decoration: underline;">عدم جواز إقامة الدعوى القضائية علي
              المشروعات</span> العاملة بنظام المناطق الحرة إلا بعد الرجوع للهيئة .</li>
          <li>عدم جواز تأميم المشروعات والمنشآت أو مصادرتها .</li>
          <li><span style="font-weight: bold; text-decoration: underline;">لا يجوز بالطريق الإداري فرض الحراسة علي
              المشروعات أو الحجز علي أموالها أو الاستيلاء أو التحفظ عليها أو تجميدها أو مصادرتها من غير الطريق
              القضائي</span> .</li>
        </ul>

        <p class="pcolor">المزايا</p>
        <p>بالإضافة الى المزايا التى يمنحها قانون الاستثمار لكافة المشروعات التي تعمل تحت مظلته , فإن احد اهم مزايا
          المناطق الحرة تتمثل في تعامل المشروع مع <span style="font-weight: bold; text-decoration: underline;">جهة
            إدارية
            واحدة هي إدارة المناطق الحرة</span> والتي تتولى التعامل مع المشروع طوال فترة حياة المشروع وفق منظومة إجراءات
          متكاملة تتميز بالتيسير والتسهيل خلال مراحل المشروع المختلفة وذلك من خلال مايلي :</p>
        <ul>
          <li>إصدار كافة الموافقات اللازمة لإقامة المشروع .</li>
          <li>إصدار ترخيص مزاولة النشاط للمشروع والذى يكتفى بالتعامل به مع كافة الجهات الحكومية ودون الحاجة للقيد في
            السجل الصناعي.</li>
          <li>انهاء إجراءات حجز وتسليم الأرض للمشروع من إدارة المنطقة فور تقديم الطلب وإنهاء الإجراءات الخاصة بذلك
            (لمشروعات المنطقة الحرة العامة).</li>
          <li>اعتماد تراخيص البناء من إدارة المنطقة فور تقديم الرسومات الهندسية ومراجعتها (لمشروعات المنطقة الحرة
            العامة)..</li>
          <li>اتخاذ كافة التعديلات اللازمة على المشروع .</li>
          <li>انهاء كافة إجراءات دخول وخروج البضائع من والى مقر المشروع من خلال اصدار اقرارات الوارد والصادر واتمام كافة
            الإجراءات الجمركية لها .</li>
          <li>اتخاذ إجراءات تصفية المشروع حال الرغبة في تصفية نشاط المشروع.</li>
        </ul>

        <p class="pcolor">أنواع المناطق الحرة</p>
        <p>هناك نوعان من المناطق : (مناطق حرة عامة – مناطق حرة خاصة) , ويختص قطاع المناطق الحرة بالإشراف عليهما.</p>

        <p class="pcolor">المناطق الحرة الخاصة</p>
        <p>هي كيان منفرد يمثل مشروعا واحدا مستقلا (أو أكثر من مشروع في أنشطة مماثلة) متى اقتضت طبيعتها ذلك ويتحتم
          تواجده خارج نطاق المناطق الحرة العامة وفقا لاقتصاديات المشروع وطبيعة نشاطه التي تحتم تواجده بمواقع معينه
          للاستفادة من المزايا التي يتيحها هذا الموقع من حيث القرب من مصادر المواد الخام ومستلزمات الإنتاج أو أسواق
          التصدير أو العمالة اللازمة أو التكامل مع مشروعات قريبة أو الحاجة إلى قربه من ميناء أو طريق بري معين.</p>
        <p>ويكون موقع المنطقة الحرة الخاصة إما مملوكا للمستثمر أو مستأجره له .</p>
        <p>وللاطلاع على مستندات وإجراءات إقامة المشروع بنظام المناطق الحرة الخاصة <a href="assets/Ar_Pub_all_final.pdf"
            class="pcolor">اضغط
            هنا</a>
        </p>

        <p class="pcolor">المناطق الحرة العامة</p>
        <p>يوجد حاليا عدد (9) مناطق حرة عامة منتشرة بأنحاء الجمهورية بكل من (الإسكندرية "العامرية" – القاهرة "مدينة نصر"
          – بورسعيد – السويس "ثلاث مواقع ببورتوفيق والأدبية وعتاقة" – الإسماعيلية – دمياط – شبين الكوم – مدينة الإنتاج
          الاعلامى – قنا "مدينة قــفــط") مزودة بالمرافق والبنية الأساسية اللازمة للتشغيل واستقبال المشروعات (طرق-كهرباء
          - محطات صرف صحى – شبكات مياه – تليفونات ) بالإضافة الى وحدة جمركية متكاملة ووحدة لشرطة امن الموانئ ووحدة امن
          بكل منطقة تعمل على مدى 24 ساعة وقد روعى ان يتم اختيار مواقع المناطق الحرة بحيث تتواجد بالمدن الكبرى المميزة
          بموقعها وتوافر العمالة وامكانياتها الداعمة للمنطقة وبالقرب من الموانئ البحرية والجوية وتخصص مساحات الاستثمار
          فيها بنظام مقابل الانتفاع السنوي / متر مربع حسب نوع النشاط الذى يزاوله المشروع</p>
        <p>وللاطلاع على مستندات وإجراءات إقامة المشروع بنظام المناطق الحرة العامة <a href="assets/Ar_Pub_all_final.pdf"
            class="pcolor">اضغط
            هنا</a>
        </p>

        <p>للمزيد من المعلومات عن المناطق الحرة و الفرص الاستثمارية بها <a
            href="https://www.investinegypt.gov.eg/Arabic/Pages/explore.aspx?map=true" class="pcolor">اضغط هنا</a></p>
      </div>
      <div class="col-md-3">
        <app-fixed-go-on></app-fixed-go-on>
      </div>
    </div>
  </div>
</div>